import { useMutation, useQueryClient } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'

interface ToggleEnabledParams {
  id: string
  enabled: boolean
}

export function useToggleEnabledMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, enabled }: ToggleEnabledParams) => {
      await fetchApi({
        endpoint: `/api/configurations/update/${id}/toggle`,
        method: 'PATCH',
        body: { settings: { enabled } },
      })

      return { id, enabled }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['configurations', 'list'],
        refetchType: 'active',
      })
    },
  })
}
